<template>
  <div class="Links">
      <LinksPre/>
  </div>
</template>

<script>
import LinksPre from "@/components/LinksPre.vue"
import {mapActions} from 'vuex'

export default {
  name: 'Links',
  components:{
    LinksPre
  },
  data(){
    return{
    }
  },
  methods:{
     ...mapActions([
      'getLinks',
      'getImage',
      'getStyle',
     ])
  },
  mounted(){
    let name = this.$route.params.name
    this.getImage(name)
    this.getStyle(name)
    this.getLinks(name)
  }
}
</script>

<style scoped lang="scss">
//default layout 
.Links{
  min-height:100%;
  display: contents;
}

</style>

